import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import Moment from 'moment';
import { connect } from 'react-redux';
import { getList, getDescriptions, setPaginaAtual } from './contagemVolumetricaActions';
import { Modal } from 'react-bootstrap';
import { parseISO, format, isValid } from 'date-fns';
import ReactTableGT2A from '../common/grid/gridReactTable';
import PremiumTableShell from '../common/grid/premiumTableShell';
import LabelTooltip from '../common/form/labelTooltip';
import { PAGE_SIZE } from '../common/utils/pageSize';
import TimeRangeFilter from './TimeRangeFilter';
import './contagemVolumetrica.css';

class ControladorContagemVolumetricaList extends Component {
  constructor() {
    super();

    this.handleClose = this.handleClose.bind(this);
    this.handleChangeTime = this.handleChangeTime.bind(this);
    this.fetchData = this.fetchData.bind(this);

    this.state = {
      show: false,
      data: [],
      pages: null,
      loading: true,
      filtered: [],
      sorted: [],
    };
  }

  handlePageChange = page => {
    this.props.setPaginaAtual(page); // Atualiza a página no Redux

    // Forçar recarregamento dos dados da nova página
    const currentState = {
      page: page,
      sorted: this.state.sorted,
      filtered: this.state.filtered,
      pageSize: PAGE_SIZE,
    };

    this.fetchData(currentState);
  };

  componentWillMount() {
    this.props.getDescriptions();
  }

  componentDidUpdate(prevProps) {
    // Se a página mudou no Redux e os dados estão vazios, carregar nova página
    if (
      prevProps.paginaAtual !== this.props.paginaAtual &&
      (!this.props.data || this.props.data.length === 0) &&
      !this.state.loading
    ) {
      const currentState = {
        page: this.props.paginaAtual || 0,
        sorted: this.state.sorted,
        filtered: this.state.filtered,
        pageSize: PAGE_SIZE,
      };

      // Pequeno delay para evitar conflitos de estado
      setTimeout(() => {
        this.fetchData(currentState);
      }, 100);
    }
  }

  fetchData(state) {
    // Limpar dados anteriores para evitar "dados fantasma"
    this.setState({
      loading: true,
      filtered: state.filtered,
      sorted: state.sorted,
      data: [], // Limpar dados anteriores
    });

    // Notificar o componente pai sobre mudanças no estado da tabela para impressão
    if (this.props.onTableStateChange) {
      this.props.onTableStateChange(state);
    }

    this.props
      .getList(state.page, state.sorted, state.filtered, this.props.agrupador)
      .then(() => {
        this.setState({
          loading: false,
        });
      })
      .catch(error => {
        console.error('Erro ao carregar dados da contagem volumétrica:', error);
        this.setState({
          loading: false,
        });
      });
  }

  timeFormat(time) {
    let timeFormatted = time.replace(/\D/g, '');
    let hour = timeFormatted.substring(0, 2);
    let minute = timeFormatted.substring(2, 4);
    let second = timeFormatted.substring(4, 6);
    hour = hour > 23 ? '23' : hour;
    minute = minute > 59 ? '59' : minute;
    second = second > 59 ? '59' : second;
    return `${hour}${minute ? ':' + minute : ''}${second ? ':' + second : ''}`;
  }

  handleChangeTime(value, onChange) {
    const time = this.timeFormat(value);
    onChange(time);
  }

  handleClose() {
    this.setState({ show: false });
  }

  render() {
    Moment.locale('pt-br');
    const descricoes = this.props.descriptions || {};
    const { data, total } = this.props;
    const paginaAtual = this.props.paginaAtual;
    const pages = Math.ceil(total / PAGE_SIZE);

    const columns = [
      {
        Header: 'Data',
        accessor: 'data_contagem',
        width: 150,
        filterable: true,
        resizable: true,
        className: 'column_grid column_center',
        Cell: ({ value }) => Moment(value).format('DD/MM/YYYY'),
        Filter: ({ filter, onChange }) => (
          <input
            type="date"
            onChange={event => onChange(event.target.value)}
            style={{ width: '100%' }}
            value={filter ? filter.value : ''}
          />
        ),
        filterMethod: (filter, row) => {
          if (isValid(parseISO(row[filter.id]))) {
            const dataValue = format(parseISO(row[filter.id]), 'yyyy-MM-dd');
            return dataValue === filter.value;
          }
        },
      },
      {
        Header: 'Hora',
        accessor: 'hora_contagem',
        width: 180,
        className: 'column_grid column_center',
        filterable: true,
        resizable: true,
        Filter: ({ filter, onChange }) => <TimeRangeFilter filter={filter} onChange={onChange} />,
        filterMethod: (filter, row) => {
          if (!filter.value) return true;

          try {
            const filterData = JSON.parse(filter.value);
            const rowTime = row[filter.id];

            if (!rowTime) return false;

            const { start, end } = filterData;

            // Se só tem hora início, pesquisa por intervalo (comportamento antigo)
            if (start && !end) {
              // Simular o comportamento do timeFormatter no frontend
              const startHour = start.split(':')[0];
              const startMinute = start.split(':')[1] || '00';
              const startSecond = start.split(':')[2] || '00';

              const initialTime = `${startHour}:${startMinute}:${startSecond}`;
              const finalTime = `${startHour}:${startMinute.length === 1 ? startMinute + '9' : startMinute}:${
                startSecond.length === 1 ? startSecond + '9' : startSecond
              }`;

              return rowTime >= initialTime && rowTime <= finalTime;
            }

            // Se tem os dois, pesquisa por between (inclusivo) - garantir formato correto
            if (start && end) {
              // Garantir que as horas tenham formato completo para comparação
              const startFormatted = start.includes(':')
                ? start.split(':').length === 2
                  ? start + ':00'
                  : start
                : start + ':00:00';
              const endFormatted = end.includes(':')
                ? end.split(':').length === 2
                  ? end + ':59'
                  : end
                : end + ':59:59';
              return rowTime >= startFormatted && rowTime <= endFormatted;
            }

            // Se só tem hora fim, pesquisa por menor ou igual (inclusivo)
            if (!start && end) {
              // Garantir que a hora fim seja inclusiva
              const endFormatted = end.includes(':')
                ? end.split(':').length === 2
                  ? end + ':59'
                  : end
                : end + ':59:59';
              return rowTime <= endFormatted;
            }

            return true;
          } catch (e) {
            // Se não conseguir fazer parse do JSON, usar o comportamento padrão
            return row[filter.id] && row[filter.id].includes(filter.value);
          }
        },
      },
    ];

    for (let laco = 1; laco <= 16; laco++) {
      let label = laco,
        key = 'laco_' + laco;
      if (descricoes.hasOwnProperty(key)) {
        label = <LabelTooltip text={label} className="text-underline" tooltip={descricoes[key]} />;
      }

      columns.push({
        Header: label,
        accessor: 'laco_' + laco,
        filterable: true,
        resizable: true,
        className: 'column_grid column_center',
        width: 53,
      });
    }

    return (
      <div>
        <Modal show={this.state.show} onHide={this.handleClose} dialogClassName="modal-load" backdrop={false} />

        <style>{`
          .contagem-volumetrica-premium-table .ReactTable .rt-th.column_center,
          .contagem-volumetrica-premium-table .ReactTable .rt-td.column_center {
            justify-content: center;
            text-align: center;
          }

          .contagem-volumetrica-premium-table .ReactTable .rt-th .rt-resizable-header-content,
          .contagem-volumetrica-premium-table .ReactTable .rt-th .rt-th-content {
            width: 100%;
            text-align: center;
            justify-content: center;
          }
        `}</style>

        <div className="contagem-volumetrica-premium-table">
          <PremiumTableShell
            summary={`${data.length} registro(s) na página atual, ${total || 0} no total`}
            loading={this.state.loading}
            loadingText="Carregando contagem volumétrica..."
            tableMinWidth={0}
          >
            <ReactTableGT2A
              manual
              data={data}
              columns={columns}
              pages={pages}
              onFetchData={this.fetchData}
              loading={this.state.loading}
              filterable
              className="-striped -highlight"
              defaultPageSize={PAGE_SIZE}
              showPaginationBottom={true}
              onPageChange={this.handlePageChange}
              page={paginaAtual}
            />
          </PremiumTableShell>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  data: state.controladorContagemVolumetrica.list,
  descriptions: state.controladorContagemVolumetrica.descriptions,
  total: state.controladorContagemVolumetrica.total,
  paginaAtual: state.controladorContagemVolumetrica.paginaAtual,
});
const mapDispatchToProps = dispatch => bindActionCreators({ getList, getDescriptions, setPaginaAtual }, dispatch);
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ControladorContagemVolumetricaList);
